import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { MainDialog, Options } from '../../UI';
import { useContext } from 'react';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';
import ClinicForm from './ClinicForm';

const style = makeStyles({
    container: {
        padding: '16px 0',
        borderBottom: 'solid 1px rgba(206, 210, 214, 0.8)',
        position: 'relative',
        cursor: 'pointer'
    },
    clinicName: {
        color: '#232733',
        fontSize: '13px',
        fontWeight: '500'
    }
});
const ClinicRow = ({ item }) => {
    const classes = style();
    const { lang } = useContext(LanguageContext);
    const { messages } = useContext(MessagesContext);
    const [showOption, setShowOption] = useState(false);
    const options = [{ label: messages.editInfo, icon: 'edit', value: 1 }];
    const [dialog, setDialog] = useState(false);

    const handleSelectOptions = ({ value }) => {
        if (value === 1) {
            setDialog(true);
        }
    };
    return (
        <>
            <MainDialog
                open={dialog}
                title={messages.editClinic}
                goBack={() => setDialog(false)}
                minHeight="300"
            >
                <ClinicForm clinic={item} isEditing handleClose={() => setDialog(false)} />
            </MainDialog>
            <div
                className={classes.container}
                onMouseEnter={() => setShowOption(true)}
                onMouseLeave={() => setShowOption(false)}
                onBlur={() => setShowOption(false)}
            >
                <span>{item.name}</span>
                <div>
                    <Options
                        top="2"
                        left={lang === 'fa' ? '2' : undefined}
                        right={lang !== 'fa' ? '2' : undefined}
                        width={'24px'}
                        options={options}
                        isSetting
                        showIcon={showOption}
                        handleSelect={handleSelectOptions}
                    />
                </div>
            </div>
        </>
    );
};
ClinicRow.propTypes = {
    item: PropTypes.object
};
export default ClinicRow;
